/** Append a cache-buster (`?v=<renderAt>`) to a render image URL so an
 * overwritten render — same render_hash/URL but new bytes, e.g. a tier2→ben2
 * cutout swap — is not served stale from the browser's immutable cache (renders
 * ship `Cache-Control: immutable, max-age=86400`). `renderAt` is the render's
 * rendered_at epoch seconds; when the render changes, it changes, busting the
 * cache. No-op when renderAt is missing. */
export function bustRender(url: string, renderAt?: number | null): string {
  if (renderAt == null) return url;
  return `${url}${url.includes('?') ? '&' : '?'}v=${renderAt}`;
}
